/* eslint-disable no-unused-expressions */
import { NOTIFICATION_HANDLER } from '@Constants/types';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import store from '@Store';

const filterByAnswer = (AnswersFlagsInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    Object.values(AnswersFlagsInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => {
                let curValue = value.answerField.values[0].value.toLowerCase();
                if (option.text === 'Other')
                    return curValue.startsWith('yes') || curValue.startsWith('no');
                return !curValue.startsWith(option.text.toLowerCase());
            });
        }
    });

    return filteredCards;
};
const filterBySuggestedClauses = (suggestedClauseInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    Object.values(suggestedClauseInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => {
                if (option.text === 'No') {
                    return value.suggestedClauseGroups && value.suggestedClauseGroupsMap;
                }
                return !value.suggestedClauseGroups || !value.suggestedClauseGroupsMap;
            });
        }
    });

    return filteredCards;
};
const filterByExtractions = (extractionFlagsInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    Object.values(extractionFlagsInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => {
                const filteredAnalytics = value.analytics.filter(
                    analytic =>
                        analytic.values[0].value && analytic.values[0].value !== 'No extraction'
                );
                if (option.text === 'No') {
                    return filteredAnalytics.length > 0;
                }
                return filteredAnalytics.length === 0;
            });
        }
    });

    return filteredCards;
};
const filterByTopics = (topicFlagsInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    Object.values(topicFlagsInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => value.topic !== option.text);
        }
    });

    return filteredCards;
};
const filterBySubTopics = (subTopicFlagsInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    Object.values(subTopicFlagsInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => value.subtopic !== option.text);
        }
    });

    return filteredCards;
};
const sortByRiskLevels = (SortFlagsInput, scoreCardElementList) => {
    if (SortFlagsInput && SortFlagsInput.RiskLH && SortFlagsInput.RiskLH.selected)
        return scoreCardElementList.sort((a, b) => b.riskSeverity - a.riskSeverity);

    if (SortFlagsInput && SortFlagsInput.RiskHL && SortFlagsInput.RiskHL.selected)
        return scoreCardElementList.sort((a, b) => a.riskSeverity - b.riskSeverity);

    return scoreCardElementList;
};
const sortByTopic = (SortFlagsInput, scoreCardElementList) => {
    if (SortFlagsInput && SortFlagsInput.TOPICAZ && SortFlagsInput.TOPICAZ.selected) {
        return scoreCardElementList.sort((a, b) => a.topic.localeCompare(b.topic));
    }
    if (SortFlagsInput && SortFlagsInput.TOPICZA && SortFlagsInput.TOPICZA.selected)
        return scoreCardElementList.sort((a, b) => b.topic.localeCompare(a.topic));

    return scoreCardElementList;
};

const updateRiskLevelCounts = (riskFlagsInput, filteredScoreCardList) => {
    const countOccurrences = (arr, val) =>
        arr.reduce((acc, arrValue) => (arrValue.riskSeverity === val ? acc + 1 : acc), 0);

    Object.keys(riskFlagsInput).forEach(key => {
        const count = countOccurrences(filteredScoreCardList, riskFlagsInput[key].severity);
        riskFlagsInput[key].count = count;
        return true;
    });
    return null;
};

const filterByRiskLevels = (riskFlagsInput, scoreCardElementList) => {
    let filteredCards = scoreCardElementList;

    updateRiskLevelCounts(riskFlagsInput, filteredCards);

    Object.values(riskFlagsInput).forEach(option => {
        if (!option.selected) {
            filteredCards = filteredCards.filter(value => value.riskSeverity !== option.severity);
        }
    });

    return filteredCards;
};

const filters = {
    filterByAnswer,
    filterBySuggestedClauses,
    filterByExtractions,
    filterByTopics,
    filterBySubTopics,
    sortByRiskLevels,
    sortByTopic,
    filterByRiskLevels
};

export const filterAndSortScoreCard = (
    curActiveFilters,
    scoreCardElementList,
    riskFlagsInput,
    SortFlagsInput
) => {
    try {
        let filteredCards = [...scoreCardElementList];
        const filterKeys = Object.keys(curActiveFilters);

        filterKeys.forEach(activeFilter => {
            const { flags, active } = curActiveFilters[activeFilter];

            filteredCards =
                activeFilter !== 'filterByRiskLevels' && active
                    ? filters[activeFilter](flags, filteredCards)
                    : filteredCards;
        });

        filteredCards = sortByRiskLevels(SortFlagsInput, filteredCards);
        filteredCards = filterByRiskLevels(riskFlagsInput, filteredCards);

        return filteredCards;
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'scorecardContainer.filterAndSortScoreCard', err);
        store.dispatch({ type: NOTIFICATION_HANDLER.ERROR, payload: err });
        return null;
    }
};

export const initialFilterAndSortScoreCard = (
    scoreCardElementList,
    riskFlagsInput,
    SortFlagsInput
) => {
    try {
        let filteredCards = [...scoreCardElementList];

        filteredCards = sortByRiskLevels(SortFlagsInput, filteredCards);
        filteredCards = filterByRiskLevels(riskFlagsInput, filteredCards);

        return filteredCards;
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'scorecardContainer.initialFilterAndSortScoreCard', err);
        store.dispatch({ type: NOTIFICATION_HANDLER.ERROR, payload: err });
        return null;
    }
};
